import React, { useCallback, useContext } from 'react';
import ListingFilterSelect from '@michelin/acid-components/build/components/ListingFilters/ListingFilterSelect';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { ListItemIcon, ListItemText, MenuItem } from '@material-ui/core';
import { CentralProviderContext } from '../../centralProviderContext/CentralProviderContext';
import { navigateToMichelin } from '../../helpers/navigateToMichelin';
import { NavigateDataType } from '../../types/NavigateData';
import { getAppIconByName } from '../../helpers/getAppIconByName';
import { AuthContext } from '../../authContext/AuthContext';
var useStyles = makeStyles(function (theme) { return createStyles({
    listItem: {
        '& div': {
            fill: theme.palette.primary.main,
        },
    },
}); });
export var AppSwitch = function () {
    var CP_CTX = useContext(CentralProviderContext);
    var authResult = useContext(AuthContext).authResult;
    var classes = useStyles();
    var getIcon = function (e) { return getAppIconByName(e === null || e === void 0 ? void 0 : e.name); };
    var handleLink = useCallback(function (data) {
        var _a;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        var CLICKED_APP = apps.find(function (a) { return a.app_key === data; });
        if (CLICKED_APP) {
            navigateToMichelin(CLICKED_APP.url, {
                auth: true,
                type: NavigateDataType.NAVIGATE,
                authInfo: authResult,
                profile: (_a = CP_CTX.centralProfile) === null || _a === void 0 ? void 0 : _a.auth0,
                data: CP_CTX,
            }, '_top');
        }
    }, [CP_CTX]);
    if (!CP_CTX.centralProfile)
        return null;
    var selectedApp = CP_CTX.centralProfile.applications.find(function (a) { return a.app_key === CP_CTX.application; });
    var apps = CP_CTX.centralProfile
        ? CP_CTX.centralProfile.applications
            .sort(function (a, b) { return a.name.toLowerCase().localeCompare(b.name.toLowerCase()); })
        : [];
    var listOptions = apps.map(function (app) { return ({
        label: app.name,
        value: app.app_key,
    }); });
    return (React.createElement(MenuItem, null,
        React.createElement(ListItemIcon, { style: { minWidth: '24px', paddingRight: '8px' }, className: classes.listItem }, getIcon(selectedApp)),
        React.createElement(ListItemText, null,
            React.createElement(ListingFilterSelect, { value: selectedApp === null || selectedApp === void 0 ? void 0 : selectedApp.app_key, onChange: function (e) { return handleLink(e.target.value); }, options: listOptions, disableUnderline: true }))));
};
//# sourceMappingURL=AppSwitch.js.map